export const AVAILABLE_TO_BILL_BILLING_TRANSACTION_REDIRECT_KEY =
  'available-to-bill-to-billing-transaction-redirect-key';
